import { useContext, useEffect, useRef, useState } from "react"
import { Typography, toast } from "@stardust-ds/react"
import intl from "react-intl-universal"

import EditIcon from "../../../assets/icons/EditIcon"
import MoveIcon from "../../../assets/icons/MoveIcon"
import TrashIcon from "../../../assets/icons/TrashIcon"
import RcmpEyeIconLarge from "../../../assets/icons/EyeIconLarge"
import RcmpSingleAccordion from "../../atoms/singleAccordion"
import styles from "./index.module.scss"
import PlusIcon from "../../../assets/icons/PlusIcon"
import RcmpActivitiesTable from "../ActivitiesTable"
import PurePlusIcon from "../../../assets/icons/PurePlusIcon"
import DragAndDropContext from "../../../contexts/DragAndDropContext"
import { Draggable, Droppable } from "react-beautiful-dnd"
import useDataApi from "../../../hooks/useDataApi"
import { fnCheckHasForm, fnDuplicateBlock, fnListBlocks } from "../../../services/blocks"
import RcmpModalInfo from "../../organisms/ModalInfo"
import Button from "../../atoms/Button"
import MoveEllipsisIcon from "../../../assets/icons/MoveEllipsisIcon"
import SaveIcon from "../../../assets/icons/SaveIcon"
import InfiniteScroll from "../../atoms/InfiniteScroll"
import { BlocksContext } from "../../../contexts/Blocks"
import { useParams } from "react-router"
import ErrorContext from "../../../contexts/Error"
import AuthContext from "../../../contexts/Auth"
import CopyIcon from "../../../assets/icons/CopyIcon"
import RcmpLoading from "../../atoms/Loading"
import RcmpArrowDownSingleAccordion from "../../../assets/icons/ArrowDownSingleAccordion"
import "./index.css"
import RcmpKanban from "../Kanban"
import BoardContext from "../../../contexts/Board"

import QrCodeIcon from "../../../assets/icons/QrCodeIcon"
import { QRCodeCanvas } from "qrcode.react"

export default function RcmpBlocksList(props) {
  const {
    aData,
    fnDeleteBlock,
    fnSetCBlockName,
    fnSetBisEdit,
    fnSetBModalIsOpen,
    fnHandleModalMoveOpen,
    oBlockData,
    fnSetABlockData,
    fnAddActivity,
    fnHandleModalEditActivity,
    fnReorderActivitiesSubmit,
    oReorderActivitiesRes,
    bObserver,
    fnSubmitGetActivities,
    oGetActivitiesRes,
    fnOpenCustomFields,
    fnReorderBlocksSubmit,
    fnMoveActivitySubmit,
    fnUpdateActivityBlocks,
    aAllFields,
    fnSetSortBlocks,
    bSortBlocks,
    oOrderBlockRes,
    oCurrentBoard,
    bCanChangeBlock,
    fnSetBIsVisibleFieldsTable,
    bIsObserverBoard,
    oCurrentModel,
    nBlockViewMode,
    oMoveActivity,
    fnReorderActivitiesReq,
    fnSetBModalModelActivityIsOpen,
  } = props
  const [bShowTable, fnSetBShowTable] = useState(true)
  const [aBlocksToList, fnSetABlocksToList] = useState([])
  const [aBlocksSort, fnSetABlocksSort] = useState()
  const [bCanDrop, fnSetBCanDrop] = useState(true)
  const [bCanDropActivity, fnSetBCanDropActivity] = useState(true)
  const [bOpenModalDeleteBlockWarning, fnSetBOpenModalDeleteBlockWarning] =
    useState(false)
  const [bOpenModalDuplicateBlock, fnSetBOpenModalDuplicateBlock] = useState(false)
  const [oCanDeleteBlockForm, fnSubmitCanDeleteBlockForm] = useDataApi(fnCheckHasForm)
  const [oDuplicateBlockRes, fnSubmitDuplicateBlock] = useDataApi(fnDuplicateBlock)
  const { bIsOpenErrorModal, fnOpenErrorModal } = useContext(ErrorContext)
  const { boardId: nBoardId, panelId: nPanelId } = useParams()
  const { oUser } = useContext(AuthContext)
  const nUserId = oUser?.data?.user_nid

  const { oDragResult, bIsOpenBlocks, fnSetODragResult } = useContext(DragAndDropContext)
  const { oUpdateBoardModelRes } = useContext(BoardContext)
  const {
    fnSetOparams,
    aBlocks,
    fetchBlocksWithParams,
    fnGetActivitiesByBlockPages,
    oActivityByBlockRes,
    fnResetBlock,
    fnSetOCurrentBlock,
    oCurrentBlock,
    aBlocksToOrder,
    fnSetABlocksToOrder,
    oListBlocksPagination,
    oActivitiesRequestDone,
  } = useContext(BlocksContext)

  const [oBlockRes, fnGetBlockReq] = useDataApi(fnListBlocks)
  const accordionRef = useRef([])
  const qrCodeRef = useRef([])
  const baseUrl = window.location.origin + process.env.PUBLIC_URL + "/"

  const aBlocksDetails = aBlocksToList?.map((d, index) => {
    const activities = d?.activities?.map((activity) => ({
      ...activity,
      id: activity?.id || activity?.opat_nid,
      originId: index,
    }))
    const activities_pending = d?.activities_pending?.map((activity) => ({
      ...activity,
      id: activity?.id || activity?.opat_nid,
      originId: index,
    }))

    return {
      bActivitiesLength: !d?.activities?.length && !d?.activities_pending?.length,
      nActivityLegth: d?.activities?.length
        ? d?.activities?.length
        : d?.activities_pending?.length,
      aData: activities?.length ? activities : activities_pending,
      id: d.opbl_nid,
      total: d.total,
    }
  })

  useEffect(() => {
    let cDragResult = oDragResult ? oDragResult?.draggableId : ""
    if (cDragResult.includes("block")) {
      fnSetBShowTable(bIsOpenBlocks)
      return fnSetBCanDrop(bIsOpenBlocks)
    } else if (cDragResult.includes("draggable")) {
      fnSetBCanDropActivity(bIsOpenBlocks)
    } else {
      fnSetBCanDrop(true)
    }
  }, [bIsOpenBlocks, oDragResult])

  useEffect(() => {
    const aFilteredFields = oCurrentBoard?.board_model?.fields || []

    const aBlocksFormated = aData.map((oBlock) => {
      const activities = oBlock?.activities?.map((activity) => ({
        ...activity,
        id: activity?.id || activity.opat_nid,
        originId: oBlock.opbl_nid,
      }))
      const activities_pending = oBlock?.activities_pending?.map((activity) => ({
        ...activity,
        id: activity?.id || activity.opat_nid,
        originId: oBlock.opbl_nid,
      }))

      return {
        ...oBlock,
        name: oBlock.opbl_cname,
        id: oBlock.opbl_nid,
        fieldsName: aFilteredFields.map((oField) => ({
          ...oField,
          opfd_nid: oField.ombf_opfd_nid,
          position: oField.ombf_nposition,
        })),
        bActivitiesLength:
          !oBlock?.activities?.length && !oBlock?.activities_pending?.length,
        nActivityLegth: oBlock?.activities?.length
          ? oBlock?.activities?.length
          : oBlock?.activities_pending?.length,
        aData: [...activities, ...activities_pending],
        total: oBlock.total,
      }
    })
    fnSetABlocksToList(aBlocksFormated)
  }, [aData])

  useEffect(() => {
    if (oUpdateBoardModelRes.loading) return
    const aFilteredFields = oCurrentBoard?.board_model?.fields || []

    const aBlocksFormated = aBlocks.map((oBlock) => {
      const activities = oBlock?.activities?.map((activity) => ({
        ...activity,
        id: activity.opat_nid,
        originId: oBlock.opbl_nid,
      }))
      const activities_pending = oBlock?.activities_pending?.map((activity) => ({
        ...activity,
        id: activity.opat_nid,
        originId: oBlock.opbl_nid,
      }))

      return {
        ...oBlock,
        name: oBlock.opbl_cname,
        id: oBlock.opbl_nid,
        fieldsName: aFilteredFields.map((oField) => ({
          ...oField,
          opfd_nid: oField.ombf_opfd_nid,
          position: oField.ombf_nposition,
        })),
        bActivitiesLength:
          !oBlock?.activities?.length && !oBlock?.activities_pending?.length,
        nActivityLegth: oBlock?.activities?.length
          ? oBlock?.activities?.length
          : oBlock?.activities_pending?.length,
        aData: [...activities, ...activities_pending],
        total: oBlock.total,
      }
    })
    if (oMoveActivity.loading || oMoveActivity.data) return
    fnSetABlocksToList(aBlocksFormated)
  }, [aBlocks, oReorderActivitiesRes, oUpdateBoardModelRes])

  //Update values when chamge model
  useEffect(() => {
    if (oUpdateBoardModelRes.loading) return
    ;(async () => {
      const aFilteredFields =
        oCurrentBoard?.board_model?.fields?.filter(
          (field, index, self) =>
            index === self.findIndex((f) => f.ombf_opfd_nid === field.ombf_opfd_nid),
        ) || []

      const aBlocksFormated = aBlocks.map((oBlock) => {
        const activities = oBlock?.activities?.map((activity) => ({
          ...activity,
          id: activity.opat_nid,
          originId: oBlock.opbl_nid,
        }))
        const activities_pending = oBlock?.activities_pending?.map((activity) => ({
          ...activity,
          id: activity.opat_nid,
          originId: oBlock.opbl_nid,
        }))

        return {
          ...oBlock,
          name: oBlock.opbl_cname,
          id: oBlock.opbl_nid,
          fieldsName: aFilteredFields.map((oField) => ({
            ...oField,
            opfd_nid: oField.ombf_opfd_nid,
            position: oField.ombf_nposition,
          })),
          bActivitiesLength:
            !oBlock?.activities?.length && !oBlock?.activities_pending?.length,
          nActivityLegth: oBlock?.activities?.length
            ? oBlock?.activities?.length
            : oBlock?.activities_pending?.length,
          aData: [...activities, ...activities_pending],
          total: oBlock.total,
        }
      })
      fnSetABlocksToList(aBlocksFormated)
    })()
  }, [oUpdateBoardModelRes, oCurrentBoard])

  function fnLoadMoreActivities(nBlockId, oBlock) {
    if (oBlock.can_load_more === false) return
    fnSetOCurrentBlock(oBlock)
    fnGetActivitiesByBlockPages(nBlockId)
  }

  useEffect(() => {
    if (!bSortBlocks || aBlocksSort?.length > 0) return
    fnSetABlocksSort(aBlocksToOrder)
  }, [bSortBlocks, aBlocksToList, aBlocksToOrder])

  async function handleDragEnd(result) {
    let tempData = [...aBlocksSort]
    let [selectedRow] = tempData.splice(result.source.index, 1)
    tempData.splice(result.destination.index, 0, selectedRow)

    fnSetABlocksSort(tempData)
    fnSetODragResult(null)
  }

  useEffect(() => {
    if (!oDragResult?.destination || !oDragResult.draggableId.includes("block")) return
    handleDragEnd(oDragResult)
  }, [oDragResult])

  useEffect(() => {
    if (!oDuplicateBlockRes.done || !oDuplicateBlockRes.data) return
    ;(async () => {
      await fetchBlocksWithParams({ nBoardId })
    })()
  }, [oDuplicateBlockRes])

  function fnCheckBlockHasActivity(oBlock) {
    return oBlock?.activities?.length > 0 || oBlock?.activities_pending?.length > 0
  }

  async function fnOnDeleteBlock() {
    const nBoardId = oBlockData?.opbl_opbd_nid
    const response = await fnGetBlockReq(nBoardId, "show_done=1")
    const oBlock = response?.data?.data?.find(
      (oBlock) => oBlock?.opbl_nid === oBlockData?.opbl_nid,
    )

    const responseCheckForm = await fnSubmitCanDeleteBlockForm(oBlockData?.opbl_nid)
    if (!responseCheckForm?.data?.canDestroy && !fnCheckBlockHasActivity(oBlock)) {
      fnOpenErrorModal(intl.get("BlocksPage.delete_block_with_activity"))
      return
    }

    fnSetBOpenModalDeleteBlockWarning(true)

    if (!fnCheckBlockHasActivity(oBlock)) {
      fnSetCBlockName(oBlockData)
      fnSetABlockData(oBlockData)
      fnSetBOpenModalDeleteBlockWarning(false)
      fnDeleteBlock(true)
    }
  }

  function fnOnEditBlock() {
    fnSetBisEdit(true)
    fnSetBModalIsOpen(true)
    fnSetCBlockName(oBlockData)
  }

  function fnHandleOpenVisibleFields() {
    fnOpenCustomFields(oBlockData)
    fnSetCBlockName(oBlockData)
    fnSetABlockData(oBlockData)
    fnSetBIsVisibleFieldsTable((prev) => !prev)
  }

  function fnHandleOpenDuplicateBlockModal() {
    fnSetBOpenModalDuplicateBlock(true)
    fnSetBOpenModalDeleteBlockWarning(false)
  }

  async function downloadQR() {
    const canvas = document.getElementById(`qrCodeBlock-${oBlockData.opbl_nid}`)

    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/jpg")
        .replace("image/jpg", "image/octet-stream")
      let downloadLink = document.createElement("a")
      downloadLink.href = pngUrl
      downloadLink.download = `qrCode_${oBlockData.opbl_cname}.jpg`
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    } else {
      console.error("QR Code canvas not found.")
    }
  }

  const aCardOptions = [
    {
      label: intl.get("BlocksPage.hide_fields"),
      icon: <RcmpEyeIconLarge />,
      onClick: fnHandleOpenVisibleFields,
    },
    {
      label: intl.get("BlocksPage.see_qr_code"),
      icon: <QrCodeIcon width={26} height={22} />,
      onClick: downloadQR,
    },
    {
      label: intl.get("BlocksPage.duplicate_block"),
      icon: <CopyIcon fill={"none"} className={styles.duplicateIcon} />,
      onClick: fnHandleOpenDuplicateBlockModal,
    },
    {
      label: intl.get("BlocksPage.edit_block"),
      icon: <EditIcon />,
      onClick: fnOnEditBlock,
    },
    {
      label: intl.get("BlocksPage.move_block"),
      icon: <MoveIcon />,
      onClick: () => {
        fnHandleModalMoveOpen()
      },
    },
    {
      label: intl.get("BlocksPage.delete_block"),
      icon: <TrashIcon />,
      onClick: fnOnDeleteBlock,
    },
  ]
  function fnOpenToastErrorDuplicate() {
    return toast({
      type: "error",
      title: intl.get("table_fields.toast.fail"),
      description: intl.get("BlocksPage.modal_duplicate.duplicate_block_error"),
    })
  }

  function fnHandleOpenActivityModal(oBlock) {
    fnAddActivity(oBlock)
  }

  function fnHandleOpenEditActivityModal(oActivity, oBlock) {
    fnHandleModalEditActivity(oActivity, oBlock)
  }

  function fnHandleCloseWarningDeleteModal() {
    fnSetBOpenModalDeleteBlockWarning(false)
    fnSetBOpenModalDuplicateBlock(false)
  }

  function fnHandleAccordion(e, index) {
    accordionRef.current[index].click()
  }
  async function fnHandleDuplicateBlock(e) {
    const response = await fnSubmitDuplicateBlock(oBlockData.opbl_nid)
    fnSetOparams({ bPaginatedList: true, bUpdateList: true })
    if (response.success) {
      fnHandleCloseWarningDeleteModal()
      return
    }
    fnOpenToastErrorDuplicate()
    fnHandleCloseWarningDeleteModal()
    return
  }

  async function fnNextPage(page) {
    fnSetOparams({ bAppendToList: true, page: page })
  }

  const bReadOnly = bObserver

  function fnDisabledSortBlocks() {
    fnSetABlocksToOrder([])
    fnSetSortBlocks(false)
    fnSetABlocksSort(null)
  }

  async function fnSubmitSortBlocks() {
    fnSetABlocksToOrder([])
    if (!aBlocksSort?.length) {
      fnDisabledSortBlocks()
      return
    }

    const aNewBlocksPositions = aBlocksSort.map((oBlock, nIndex) => ({
      opbl_nid: oBlock.opbl_nid,
      opbl_nposition: nIndex,
    }))

    await fnReorderBlocksSubmit(aNewBlocksPositions)
    fnDisabledSortBlocks()
  }

  function fnGraggableStyles(isDragging, oDraggableStyle) {
    const oDragStyle = isDragging
      ? { border: "none", background: "#F6FCFF", color: "#6CB6E3" }
      : {}
    return {
      ...oDraggableStyle,
      ...oDragStyle,
    }
  }

  const bHasBoardModelFieldsConfigured = oCurrentBoard?.board_model?.fields?.length > 1

  if (bSortBlocks) {
    return (
      <div className={styles.sortBlocksContainer}>
        <p className={styles.title}>{intl.get("BlocksPage.sort_blocks")}</p>
        <Droppable droppableId="blockDraoppable">
          {(provided) => (
            <ul ref={provided.innerRef} {...provided.droppableProps}>
              {oListBlocksPagination.loading ? (
                <RcmpLoading bShow={true} />
              ) : (
                aBlocksSort?.map((oBlock, nIndex) => (
                  <Draggable
                    key={`d-block-id${oBlock?.opbl_nid}`}
                    draggableId={`d-block-id${oBlock?.opbl_nid}`}
                    index={nIndex}
                  >
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={fnGraggableStyles(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                        )}
                      >
                        <MoveEllipsisIcon
                          fill={snapshot.isDragging ? "#6CB6E3" : "#ACB4BA"}
                        />
                        {oBlock?.opbl_cname}
                      </li>
                    )}
                  </Draggable>
                ))
              )}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
        <div className={styles.buttonsContainer}>
          <Button
            variant="outline"
            liquid={true}
            onClick={fnDisabledSortBlocks}
            disabled={oOrderBlockRes.loading}
          >
            {intl.get("cancel")}
          </Button>
          <Button
            className={styles.saveButton}
            liquid={true}
            onClick={fnSubmitSortBlocks}
            isLoading={oOrderBlockRes.loading}
            iconLeft={<SaveIcon />}
          >
            {intl.get("save")}
          </Button>
        </div>
      </div>
    )
  }

  function setRef(index, el) {
    qrCodeRef.current[index] = el
  }

  if (nBlockViewMode === 1) {
    return (
      <>
        <RcmpKanban
          aHeaders={aBlocksToList}
          fnSetAHeaders={fnSetABlocksToList}
          aData={aBlocksToList}
          cBottomText={
            !bHasBoardModelFieldsConfigured
              ? intl.get("BlocksPage.configure_fields")
              : intl.get("BlocksPage.add_activity")
          }
          cNotDataText={
            !bHasBoardModelFieldsConfigured
              ? intl.get("BlocksPage.model_without_fields")
              : intl.get("BlocksPage.no_activity")
          }
          nMaxRender={30}
          bLoading={oActivitiesRequestDone}
          fnHandleOpenActivityModal={
            !bHasBoardModelFieldsConfigured
              ? fnSetBModalModelActivityIsOpen
              : fnHandleOpenActivityModal
          }
          fnReorderActivitiesSubmit={fnMoveActivitySubmit}
          oMoveActivity={oMoveActivity}
          fnSetABlocksToList={fnSetABlocksToList}
          fnReorderActivitiesReq={fnReorderActivitiesReq}
          fnHandleOpenEditActivityModal={fnHandleOpenEditActivityModal}
          aEllipsisOption={bReadOnly ? [] : aCardOptions}
          fnSetData={fnSetABlockData}
          bCanChange={bCanChangeBlock}
          fnLoadMoreActivities={fnLoadMoreActivities}
        />
        <RcmpModalInfo
          bIsOpen={bOpenModalDeleteBlockWarning}
          buttonSaveText={intl.get("close")}
          title={intl.get("BlocksPage.delete_block")}
          description={intl.get("BlocksPage.delete_block_with_activity")}
          size={"sm"}
          oResponse={oBlockRes}
          oButtonCancelProps={{ style: { display: "none" } }}
          oButtonSaveProps={{ style: { marginLeft: "auto" } }}
          fnHandleCancel={fnHandleCloseWarningDeleteModal}
          fnHandleConfirm={fnHandleCloseWarningDeleteModal}
        />
        <RcmpModalInfo
          bIsOpen={bOpenModalDuplicateBlock}
          buttonSaveText={intl.get("yes")}
          buttonCancelText={intl.get("no")}
          title={intl.get("BlocksPage.modal_duplicate.duplicate_block_header")}
          description={intl.get("BlocksPage.modal_duplicate.duplicate_block_message")}
          size={"sm"}
          fnHandleCancel={fnHandleCloseWarningDeleteModal}
          fnHandleConfirm={fnHandleDuplicateBlock}
        />
      </>
    )
  }

  if (nBlockViewMode === 0) {
    return (
      <>
        <div className={styles.droppableArea}>
          <div>
            <InfiniteScroll
              fnNext={fnNextPage}
              nTotalPages={oListBlocksPagination?.data?.data?.last_page}
              nDataLength={aBlocksToList?.length}
              bStopPagination={
                oListBlocksPagination?.data?.data?.next_page_url === null ? true : false
              }
              className={styles.InfiniteScrollContainer}
            >
              {aBlocksToList?.map((d, index) => {
                const QrCodeLink = `${baseUrl}${nPanelId}/boards/${nBoardId}/${d.opbl_nid}`
                return (
                  <div
                    key={d?.opbl_nid}
                    className={styles.blockArea}
                    id={`block-${index}`}
                    data-id={d?.opbl_nid}
                  >
                    <RcmpSingleAccordion
                      oGetData={d}
                      index={index}
                      aEllipsisOption={bReadOnly ? [] : aCardOptions}
                      fnSetData={fnSetABlockData}
                      bShowTable={bShowTable}
                      bCanChange={bCanChangeBlock}
                      onClick={() => fnResetBlock(d.opbl_nid)}
                      ref={(el) => (accordionRef.current[index] = el)}
                    >
                      <div className={styles.contentContainer}>
                        <QRCodeCanvas
                          id={`qrCodeBlock-${d.opbl_nid}`}
                          value={QrCodeLink}
                          renderAs={"canvas"}
                          size={1024}
                          level={"L"}
                          includeMargin={false}
                          ref={setRef(index, d)}
                          style={{ display: "none" }}
                        />
                        <div>
                          <RcmpActivitiesTable
                            aData={aBlocksToList[index].aData}
                            bShowTable={true}
                            fnHandleModalEditActivity={(oActivity) =>
                              fnHandleOpenEditActivityModal(oActivity, d)
                            }
                            fnReorderActivitiesSubmit={fnReorderActivitiesSubmit}
                            oBlock={d}
                            fnSubmitGetActivities={fnSubmitGetActivities}
                            oGetActivitiesRes={oGetActivitiesRes}
                            oReorderActivitiesRes={oReorderActivitiesRes}
                            fnSetABlockData={fnSetABlockData}
                            oBlockData={oBlockData}
                            bCanDrop={bCanDrop}
                            bCanDropActivity={bCanDropActivity}
                            index={index}
                            fnMoveActivitySubmit={fnMoveActivitySubmit}
                            fnUpdateActivityBlocks={fnUpdateActivityBlocks}
                            aBlocksToList={aBlocksToList}
                            aAllFields={aAllFields}
                            bCanChange={bCanChangeBlock}
                            oCurrentModel={oCurrentModel}
                            fnSetABlocksToList={fnSetABlocksToList}
                            oCurrentBoard={oCurrentBoard}
                          />
                        </div>
                      </div>
                      {aBlocksDetails[index].bActivitiesLength &&
                        bCanChangeBlock &&
                        !oActivityByBlockRes.loading && (
                          <div
                            className={styles.addFirstActivities}
                            style={{ justifyContent: "center" }}
                          >
                            {bHasBoardModelFieldsConfigured ? (
                              <>
                                <PlusIcon fill={"#415364"} />
                                <p className={styles.notActivities}>
                                  {intl.get("BlocksPage.no_activity")}
                                </p>
                                {!bReadOnly && (
                                  <p
                                    className={styles.actionText}
                                    onClick={() => fnHandleOpenActivityModal(d)}
                                  >
                                    {intl.get("BlocksPage.click_add_activity")}
                                  </p>
                                )}
                              </>
                            ) : (
                              <p className={styles.notActivities}>
                                {intl.get("BlocksPage.model_without_fields")}{" "}
                                <span
                                  className={styles.actionText}
                                  onClick={fnSetBModalModelActivityIsOpen}
                                >
                                  {intl.get("BlocksPage.click_to_configure")}
                                </span>
                              </p>
                            )}
                          </div>
                        )}
                      <div className={styles.buttonsAccordionContainer}>
                        <div className={styles.buttonsContainer}>
                          {!aBlocksDetails[index].bActivitiesLength && (
                            <>
                              <RcmpArrowDownSingleAccordion
                                style={{ transform: "rotate(180deg)", cursor: "pointer" }}
                                onClick={(e) => fnHandleAccordion(e, index)}
                              />
                              <div
                                onClick={() => {
                                  fnLoadMoreActivities(d.opbl_nid, d)
                                }}
                                className={`${styles.loadMore} ${
                                  d.can_load_more ? "" : styles.disabled
                                }`}
                                style={{
                                  pointerEvents: oActivityByBlockRes.loading
                                    ? "none"
                                    : "auto",
                                  opacity: d.can_load_more ? 1 : 0.5,
                                  cursor: d.can_load_more ? "pointer" : "not-allowed",
                                }}
                              >
                                {oCurrentBlock.opbl_nid !== d.opbl_nid && (
                                  <Typography type="l4" color="#3B454F">
                                    {intl.get("BlocksPage.see_more")}
                                  </Typography>
                                )}

                                <RcmpLoading
                                  bShow={
                                    oActivityByBlockRes.loading &&
                                    oCurrentBlock.opbl_nid === d.opbl_nid
                                  }
                                  isLoading={oActivityByBlockRes.loading}
                                  size={20}
                                />
                              </div>
                            </>
                          )}
                          {!aBlocksDetails[index].bActivitiesLength &&
                            !bReadOnly &&
                            bCanChangeBlock && (
                              <div
                                className={styles.addActivity}
                                onClick={() => fnHandleOpenActivityModal(d)}
                              >
                                <PurePlusIcon fill={"#6CB6E3"} />
                                <Typography type="l4" color="#6CB6E3">
                                  {intl.get("BlocksPage.add_activity")}
                                </Typography>
                              </div>
                            )}
                        </div>
                        <p className={styles.displaying}>
                          {intl.get("BlocksPage.displaying", {
                            from: d?.aData?.length,
                            total: d.total,
                          })}
                        </p>
                      </div>
                    </RcmpSingleAccordion>
                  </div>
                )
              })}
            </InfiniteScroll>
          </div>
        </div>
        <RcmpModalInfo
          bIsOpen={bOpenModalDeleteBlockWarning}
          buttonSaveText={intl.get("close")}
          title={intl.get("BlocksPage.delete_block")}
          description={intl.get("BlocksPage.delete_block_with_activity")}
          size={"sm"}
          oResponse={oBlockRes}
          oButtonCancelProps={{ style: { display: "none" } }}
          oButtonSaveProps={{ style: { marginLeft: "auto" } }}
          fnHandleCancel={fnHandleCloseWarningDeleteModal}
          fnHandleConfirm={fnHandleCloseWarningDeleteModal}
        />
        <RcmpModalInfo
          bIsOpen={bOpenModalDuplicateBlock}
          buttonSaveText={intl.get("yes")}
          buttonCancelText={intl.get("no")}
          title={intl.get("BlocksPage.modal_duplicate.duplicate_block_header")}
          description={intl.get("BlocksPage.modal_duplicate.duplicate_block_message")}
          size={"sm"}
          fnHandleCancel={fnHandleCloseWarningDeleteModal}
          fnHandleConfirm={fnHandleDuplicateBlock}
        />
      </>
    )
  }
}
